/**
 * US-30 — Règle de gestion des ex aequo (cf. .metier/Gestion des ex aequo_dig SCOP.xlsx).
 *
 * Pour les classements top3 / flop3 sur la page Analyse détaillée, deux thèmes
 * au même pourcentage sont départagés par un « rang OPPBTP » défini métier :
 *   - Risques : rang 1 = thème le plus prioritaire (Chute de hauteur), rang 19 = le moins prioritaire (Chute de plain-pied).
 *   - Management : rang 1 = DUERP, rang 11 = Fonctions supports.
 *
 * Règle d'application :
 *   - Top    : à % égal, on garde celui dont le rang est le PLUS BAS (plus prioritaire).
 *   - Flop   : à % égal, on garde celui dont le rang est le PLUS BAS (plus prioritaire à corriger).
 *
 * Un thème non trouvé reçoit le rang `Infinity` (i.e. le moins prioritaire).
 */
import { normalizeThemeName } from './theme-utils'

const RAW_RANK_RISQUES: Array<[string, number]> = [
  ['Chute de hauteur', 1],
  ['Ensevelissement', 2],
  ["Effondrement de l'ouvrage", 3],
  ['Risque électrique', 4],
  ['Basculement - Renversement', 5],
  ['Risque routier sur voie publique', 6],
  ['Gestion des secours', 7],
  ['Incendie et/ou explosion', 8],
  ['Heurt', 9],
  ['Poussières et fibres', 10],
  ['Écrasement', 11],
  ['Produits et agents chimiques', 12],
  ['Atteintes musculaires et articulaires', 13],
  ['Coupure ou sectionnement', 14],
  ['Vibrations mécaniques', 15],
  ['Bruit', 16],
  ['Hygiène', 17],
  ['Ambiances thermiques et climatiques', 18],
  ['Chute de plain-pied', 19],
]

const RAW_RANK_MANAGEMENT: Array<[string, number]> = [
  ['Évaluation des risques (DUERP)', 1],
  ["Plan d'action prévention", 2],
  ['Gestion des urgences', 3],
  ['Dossier chantier (modes opératoires, PPSPS…)', 4],
  ['Gestion générale des locaux, matériels et équipements de sécurité (EPC-EPI)', 5],
  ['Compétences', 6],
  ['Accueil nouveaux arrivants', 7],
  ['Analyses des accidents de travail AT', 8],
  ['Audits, visites chantier', 9],
  ['Animateur prévention (chargé de prévention, QSE)', 10],
  ['Fonctions supports (RH, administratif...)', 11],
]

function buildMap(rows: Array<[string, number]>): Map<string, number> {
  const m = new Map<string, number>()
  for (const [name, rank] of rows) {
    m.set(normalizeThemeName(name), rank)
  }
  return m
}

const RISQUE_RANKS = buildMap(RAW_RANK_RISQUES)
const MANAGEMENT_RANKS = buildMap(RAW_RANK_MANAGEMENT)

export function getRiskRank(theme: string): number {
  return RISQUE_RANKS.get(normalizeThemeName(theme)) ?? Number.POSITIVE_INFINITY
}

export function getManagementRank(theme: string): number {
  return MANAGEMENT_RANKS.get(normalizeThemeName(theme)) ?? Number.POSITIVE_INFINITY
}
